import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanLoad, Route
} from '@angular/router';

import { BEWorkflowService } from './beWorkflow.service';

@Injectable()
export class BEWorkflowGuard implements CanActivate {

    constructor(private _router: Router,
        private _beWorkflowService: BEWorkflowService) { }

    //called when we try to navigate to the given route
    //returns True if the given route can be navigated to
    canActivate(route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean
    {
        var canActivate: boolean = false;

        if ((route.routeConfig != null) 
            && (route.routeConfig.path != null)) {

            let path: string = route.routeConfig.path;
            canActivate = this.verifyWorkFlow(path);
        }

        return canActivate;
    }

    //returns True if the given route path can be navigated to
    //if not, the appropriate navigation is made
    private verifyWorkFlow(path: string): boolean {
        var byRefParams = {revisedPath: "", cancelNavigation: false};

        //if any of the previous steps are invalid, go back to the first invalid step
        this._beWorkflowService.getFirstInvalidStep(path, byRefParams);

        //if navigation is automatically cancelled (eg. if we've prompted the user to save changes first)
        if (byRefParams.cancelNavigation) {
            //this._router.navigate([this._router.url]);
            return false;
        }

        let firstPath = byRefParams.revisedPath;
        if (firstPath.length > 0) {
            let url = `/${firstPath}`;
            this._router.navigate([url]);
            return false;
        };

        return true;
    }
}